import { object, string, boolean, number } from "valibot"
import type { InferOutput } from "valibot"

export const CategorySchema = object({
  id: string(),
  title: string(),
  active: boolean(),
  results: number(),
})

export type Category = InferOutput<typeof CategorySchema>
